import { TableCellsIcon } from '@heroicons/react/24/outline';
import { COAProvider } from '../../../../types/entity';
import XeroImage from '../../../../assets/xero.png';

type ChartProviderIconProps = {
    provider?: COAProvider | null;
};

function ChartProviderIcon({ provider = null }: ChartProviderIconProps): JSX.Element {
    return (
        <div>
            {provider === COAProvider.Xero && (
                <div className="flex items-center gap-1">
                    <img className="h-9 w-9 border rounded-md p-1 shrink-0" src={XeroImage} />
                    <p className="text-sm font-medium text-gray-800">Xero</p>
                </div>
            )}
            {provider === null && (
                <div className="flex items-center gap-1">
                    <TableCellsIcon className="h-9 w-9 border rounded-md p-1 shrink-0" />
                    <p className="text-sm font-medium text-gray-800">CSV</p>
                </div>
            )}
        </div>
    );
}

export default ChartProviderIcon;
